import { EDUCATION_TYPES_MAP, EducationType } from "../school/constants/types";

export const EDUCATION_TYPE_OPTIONS = [
  {
    id: EducationType.Higher,
    name: EDUCATION_TYPES_MAP[EducationType.Higher],
  },
  {
    id: EducationType.Secondary,
    name: EDUCATION_TYPES_MAP[EducationType.Secondary],
  },
];

export const PI_CHART_COLORS = [
  "#0088FE",
  "#00C49F",
  "#FFBB28",
  "#FF8042",
  "#8884d8",
  "#95a5a5",
];

export const NO_DATA_COLOR = "#e0e0e0";
